import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Chip, Grid } from '@mui/material';

import { Icon, Utils } from 'app/main/components';
import { useSettings } from 'app/main/components/hooks';
import type { DetailsPageHeaderAdditionalInfoProps } from 'app/main/components/page-layouts';

export default function CompaniesDetailsHeaderAdditionalInfo(props: DetailsPageHeaderAdditionalInfoProps) {
	const { t } = useSettings();
	const intl = useIntl();

	return (
		<Grid container spacing={1}>
			{props.model.comp_cost_id && props.model.comp_cost_id !== 1 && (
				<Grid>
					<Chip
						className="mb-4"
						icon={<Icon icon="sleep" size={20} />}
						label={props.model.cost_title}
						size="small"
					/>
				</Grid>
			)}
			{props.model.comp_erp_customer_id && (
				<Grid>
					<Chip
						className="mb-4"
						label={
							<FormattedMessage
								id="companiesDetailsHeader.erpCustomerId"
								defaultMessage={t('COMPANIES_ERP_CUSTOMER_ID')}
								values={{ id: props.model.comp_erp_customer_id }}
							/>
						}
						size="small"
					/>
				</Grid>
			)}
			{props.model.comp_erp_supplier_id && (
				<Grid>
					<Chip
						className="mb-4"
						label={
							<FormattedMessage
								id="companiesDetailsHeader.erpSupplierId"
								defaultMessage={t('COMPANIES_ERP_SUPPLIER_ID')}
								values={{ id: props.model.comp_erp_supplier_id }}
							/>
						}
						size="small"
					/>
				</Grid>
			)}
			{props.model.comp_erp_contact_id && (
				<Grid>
					<Chip
						className="mb-4"
						label={
							<FormattedMessage
								id="companiesDetailsHeader.erpContactId"
								defaultMessage={t('COMPANIES_ERP_CONTACT_ID')}
								values={{ id: props.model.comp_erp_contact_id }}
							/>
						}
						size="small"
					/>
				</Grid>
			)}
			{props.model.comp_d_import && (
				<Grid>
					<Chip
						className="mb-4"
						label={
							<FormattedMessage
								id="companiesDetailsHeader.importDate"
								defaultMessage={t('COMPANIES_IMPORT_DATE')}
								values={{
									date: intl.formatDate(Utils.parseDate(props.model.comp_d_import)?.toDate(), {
										year: 'numeric',
										month: 'numeric',
										day: 'numeric',
										hour: 'numeric',
										minute: 'numeric'
									})
								}}
							/>
						}
						size="small"
					/>
				</Grid>
			)}
		</Grid>
	);
}
